<template>
    <div class="container">
        <div v-if="showPage" class="container">
            <div class="top">
                <img style="width: 100vw; height: 74.6vw" src="../../assets/profit/profit_bg_top.png" />

                <div class="container_user">
                    <img style="width: 10vw; height: 10vw; border-radius: 5vw;" :src="avatar" />
                    <span style="font-size: 17px; margin-left: 10px; font-weight: 500;">{{ name }}</span>
                </div>
                <!-- <div class="btn_bill">账单明细</div> -->

                <span style="position: absolute; top: 51.6vw; left: 8vw; font-size: 26px; font-weight: 500;">{{ numAll.toFixed(2) }}</span>
            </div>


            <div class="container_jifen">
                <img class="coin_image" src="./assets/jifen.webp" />
                <div style="display: flex; flex-direction: column; margin-left: 4vw">
                    <span style="font-size: 14px; color: #CCC; margin-top: 5vw;">积分收益</span>
                    <span style="font-size: 26px; color: #333; font-weight: 500; margin-top: 1vw;">{{ user_score.toFixed(2) }}</span>
                </div>
                <div style="flex: 1"></div>
                <div @click="goJifen" style="display: flex; margin-right: 4vw; width: 16vw; height: 8vw; margin-top: 8vw; color: #7678FF; align-items: center; justify-content: center; border: 1px solid #7678FF; border-radius: 4vw;">
                    兑换
                </div>
            </div>


            <div class="container_crystal">
                <img class="coin_image" src="./assets/diamond.webp" />
                <div style="display: flex; flex-direction: column; margin-left: 4vw">
                    <span style="font-size: 14px; color: #CCC; margin-top: 5vw;">钻石收益</span>
                    <span style="font-size: 26px; color: #333; font-weight: 500; margin-top: 1vw;">{{ user_jewel.toFixed(2) }}</span>
                </div>
                <div style="flex: 1"></div>
                <div @click="goDiamond" style="display: flex; margin-right: 4vw; width: 16vw; height: 8vw; margin-top: 8vw; color: #7678FF; align-items: center; justify-content: center; border: 1px solid #7678FF; border-radius: 4vw;">
                    兑换
                </div>
            </div>


            <!-- <div class="container_crystal">
                <img class="coin_image" src="./assets/crystal.webp" />
                <div style="display: flex; flex-direction: column; margin-left: 4vw">
                    <span style="font-size: 14px; color: #CCC; margin-top: 5vw;">水晶收益</span>
                    <span style="font-size: 26px; color: #333; font-weight: 500; margin-top: 1vw;">{{ user_cryst.toFixed(2) }}</span>
                </div>
                <div style="flex: 1"></div>
                <div style="display: flex; margin-right: 4vw; width: 16vw; height: 8vw; margin-top: 8vw; color: #7678FF; align-items: center; justify-content: center; border: 1px solid #7678FF; border-radius: 4vw;">
                    兑换
                </div>
            </div> -->
            <div style="width: 100vw; height: 40vw"></div>


            <div class="container_debt" v-if="showDebt">
                <div style="display: flex; flex-direction: column;">
                    <span style="font-size: 14px; margin-left: 4vw; margin-top: 5vw; color: #666">欠款账单（收益货币）</span>
                    <span style="font-size: 24px; margin-left: 4vw; margin-top: 4vw; color: red">-{{ total_debtbill_money }}</span>
                </div>
                <div style="flex: 1"></div>
                <div @click="goDebt" style="display: flex; margin-right: 4vw; width: 24vw; height: 8vw; margin-top: 12vw; color: #7678FF; align-items: center; justify-content: center; border: 1px solid #7678FF; border-radius: 4vw;">
                    查看明细
                </div>
            </div>
        </div>



        <div v-else class="loading">
            <img style="width: 20vw; height: 20vw; margin-left: 40vw; margin-top: 40vh;" src="../../assets/profit/loading.gif" />
        </div>
    </div>
</template>


<script>
import { isIos } from "../../common/functions";
import axios from 'axios';
import { prefix, prefix_dev, userBasicData, userFinance } from './url';

export default ({
    data() {
        return {
            urlPrefix: prefix,
            numAll: 0.00,
            showPage: false,
            head: {
                version: '',
                edition: '',
                aps: '',
                Authorization: '',
                os: 1,
            },

            avatar: '',
            name: '#用户昵称',
            user_score: 0.00,
            user_jewel: 0.00,
            user_cryst: 0.00,
            total_debtbill_money: 0.00,

            showDebt: false
        };
    },

    created() {
        this.formatUrlParams();
    },

    methods: {
        goDebt() {
            window.location.href = '/profit-debt';
        },

        formatUrlParams() {
            // if (isIos()) this.showPage = true;
            const url = window.location.href;
            const z = url.split('?');
            let p = {};
            if (url.includes('profit-dev')) {
                this.urlPrefix = prefix_dev;
                localStorage.setItem('is_dev', 'yes');
            } else {
                localStorage.setItem('is_dev', 'no');
            }
            try {
                const k = z[1].split('&');
                k.forEach(item => {
                    const m = item.split('=');
                    p[m[0]] = m[1];
                })

                this.head.version = p.version;
                this.head.edition = p.edition;
                this.head.aps = p.aps;
                this.head.Authorization = p.Authorization;
                localStorage.setItem("version", p.version);
                localStorage.setItem("edition", p.edition);
                localStorage.setItem("aps", p.aps);
                localStorage.setItem("Authorization", p.Authorization);
            } catch(e) { }
            
            this.getUserData();
        },

        getUserData() {
            const url = this.urlPrefix + userBasicData;
            axios.get(url, {
                headers: this.head,
            }).then(res => {
                this.showPage = true;
                // console.log('user data user data si - -- --- ---->', res.data, this.head);
                const data = res.data.data;
                this.avatar = data.user_avatar;
                this.name = data.user_name;
                if (!data) {
                    alert(res.data.msg);
                } else {
                    this.getUserFinance();
                }
            }).catch(err => { });
        },

        getUserFinance() {
            const url = this.urlPrefix + userFinance;
            axios.get(url, {
                headers: this.head,
            }).then(res => {
                const data = res.data.data;
                this.user_score = parseFloat(data.user_score);
                this.user_jewel = parseFloat(data.user_jewel);
                this.user_cryst = parseFloat(data.user_cryst);
                this.total_debtbill_money = parseFloat(data.total_debtbill_money);
                this.numAll = this.user_score + this.user_jewel + this.user_cryst;

                localStorage.setItem("user_score", data.user_score);
                localStorage.setItem("user_jewel", data.user_jewel);
                localStorage.setItem('total_debtbill_money', data.total_debtbill_money);
                localStorage.setItem('user_gold', data.user_gold);
                localStorage.setItem('user_coin', data.user_coin);
                this.showDebt = this.total_debtbill_money > 0;
            }).catch(err => { });
        },

        goJifen() {
            if (this.checkHasDebt()) return;
            window.location.href = '/profit-jifen';
        },

        goDiamond() {
            if (this.checkHasDebt()) return;
            window.location.href = '/profit-diamond';
        },

        checkHasDebt() {
            if (this.showDebt) {
                alert('请先处理欠款账单！');
            }
            return this.showDebt;
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #F4E2C6;
}
.loading {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: white;
}

.top {
    width: 100vw;
    height: 74.6vw;
    display: flex;
}
.container_user {
    position: absolute;
    top: 21vw;
    left: 6vw;
    display: flex;
    align-items: center;
}
.btn_bill {
    position: absolute;
    top: 6vw;
    right: 5vw;
    font-size: 18px;
}

.container_jifen {
    display: flex;
    width: 90vw;
    height: 24vw;
    margin-left: 5vw;
    background-color: white;
    border-radius: 10px;
}
.container_crystal {
    display: flex;
    width: 90vw;
    height: 24vw;
    margin-top: 8vw;
    margin-left: 5vw;
    background-color: white;
    border-radius: 10px;
}

.container_debt {
    position: fixed;
    display: flex;
    bottom: 0;
    width: 100vw;
    height: 28vw;
    background-color: white;
}

.coin_image {
    width: 12vw;
    height: 12vw;
    margin-top: 6vw;
    margin-left: 5vw;
}
</style>